<template>
  <div
    v-if="giftGivingReportQuestions.hasOwnProperty('family_word')"
    id="family-words"
    class="question"
  >
    <h2
      class="header"
      :class="{ required: giftGivingReportQuestions.family_word.required }"
    >
      2. {{ giftGivingReportQuestions.family_word.label }}
    </h2>
    <div class="content">
      <v-layout wrap>
        <v-flex
          xs12
          :mt-3="xsOnly"
        >
          <ul>
            <li
              v-for="(item, index) in giftGivingReportQuestions.family_word.text"
              :key="index"
              class="f-1"
            >
              {{ item }}
            </li>
          </ul>

          <div v-if="giftGivingReportQuestions.hasOwnProperty('family_word_need')">
            <p
              class="header"
              :class="{ required: giftGivingReportQuestions.family_word_need.required }"
            >
              {{ giftGivingReportQuestions.family_word_need.label }}
            </p>
            <ConfirmButtons
              v-model="familyWordNeed"
              v-validate="{ required: giftGivingReportQuestions.family_word_need.required }"
              string
              :error-messages="errors.collect('familyWordNeed')"
              :data-vv-as="' '"
              :data-vv-name="'familyWordNeed'"
              :disabled="readOnly"
            />
          </div>

          <v-textarea
            v-if="
              familyWordNeed === 'yes' ||
                !giftGivingReportQuestions.hasOwnProperty('family_word_need')
            "
            v-model="familyWords"
            v-validate="{ ...regularLongText(giftGivingReportQuestions.family_word.required, FAMILY_WORD_MAX_LENGTH) }"
            auto-grow
            rows="8"
            class="my-3"
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('familyWords')"
            data-vv-name="familyWords"
            :data-vv-as="' '"
            :disabled="readOnly"
          />
        </v-flex>
      </v-layout>
    </div>
    <v-divider class="my-4" />
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import { FIELD_LENGTH } from '@/constants/validationRules';

const { mapFields } = createHelpers({
    getterType: 'giftGivingReport/getGiftGivingReportState',
    mutationType: 'giftGivingReport/updateGiftGivingReportState'
});
export default {
    name: 'FamilyWords',
    components: { ConfirmButtons },
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            FAMILY_WORD_MAX_LENGTH: FIELD_LENGTH.MAX_LONG_FIELD_LENGTH
        };
    },
    computed: {
        ...mapFields(['familyWords', 'familyWordNeed']),
        ...mapGetters('giftGivingReport', ['giftGivingReportQuestions']),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        }
    },
    watch: {
        familyWordNeed: {
            handler (val) {
                if (val !== 'yes') {
                    this.familyWords = null;
                }
            },
            immediate: true
        }
    }
};
</script>

<style scoped></style>
